import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=d1f7896c"
import script from "./organization.ts?vue&type=script&lang=ts&external"
export * from "./organization.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports